export default __webpack_public_path__ + "static/media/mayowa.114f103a.gif";